
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 52 52"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-width":"4","fill":"none","stroke-linecap":"round"}},[_c('path',{attrs:{"d":"M12.56 41.23C6.728 41.23 2 36.502 2 30.67V15.31C2 9.478 6.728 4.75 12.56 4.75h26.88C45.272 4.75 50 9.478 50 15.31v15.36c0 5.832-4.728 10.56-10.56 10.56H30.8M26 16.27v13.44m6.72-6.72H19.28"}}),_c('path',{attrs:{"d":"M30.8 41.23c-2.966 0-6.235 1.2-9.218 2.748-4.795 2.489-6.622 3.972-8.374 2.94-1.752-1.032-1.197-3.492-.749-8.41l.101-1.118"}})])])
          )
        }
      }
    